window.addEventListener('load', function() {
    function bannerSlider() {
        let left = 0;
        let width = 2000;
        let src = $('.guide__layout__img')[0]
        setInterval(() => {
            left-=.5;
            $('.guide__layout-list').css('transform', `translateX(${left}px)`)
        }, 15)
        setInterval(() => {
            width += 550;
            $('.guide__layout__img').eq(0).clone().appendTo('.guide__layout-list');
            $('.guide__layout-list').css('width', `${width}vw`)
        }, 500)
    }

    function colSlider() {
        window.sliders = [];
        setTimeout(function() {
            $('.dcol__tabs').each(function() {
                $(this).find('.dcol__tab').eq(0).click();
            })
        }, 100)
        $('.dcol__btn--prev').click(function() {
            $(this).closest('.dcol').find('.dcol__slider')[0].swiper.slidePrev()
            // $(this).closest('.dcol').find('.dcol__slider')[0].swiper.update(true);
        })
        $('.dcol__btn--next').click(function() {
            $(this).closest('.dcol').find('.dcol__slider')[0].swiper.slideNext()
            // $(this).closest('.dcol').find('.dcol__slider')[0].swiper.update(true);
        })
        $('.dcol__tab').click(function() {
            if(!$(this).hasClass('active')) {
                let container = $(this).closest('.dcol');
                let index = $(this).attr('data-index');
                let arrows = $(this).attr('data-arrows');
                $(container).find('.dcol__slider .swiper-wrapper').find('.swiper-slide').remove()
                let id = $(container).attr('data-id');
                let tag = $(this).attr('data-tag');
                let url = $(this).attr('data-url');
                let tagTitle = $(this).attr('data-tag-title');
                let selected = $(this).attr('data-selected');
                let count = $(container).find('.dcol__fake').find('.dcol__slide').length;
                $(container).find('.dcol__blocks').addClass('hide');
                if(arrows == 'true') {
                    $(container).find('.dcol__btns').show();
                } else {
                    $(container).find('.dcol__btns').hide();
                }
                console.log(selected)
                if(url) {
                    $(container).find('.dcol__link').show();
                    $(container).find('.dcol__link').attr('href', url);
                } else {
                    $(container).find('.dcol__link').hide();
                }
                if(selected == '1') {
                    console.log('da')
                    $(container).find('.dcol__col').addClass('dcol__col--blocks')
                    $(container).addClass('dcol--selected')
                    $(`.dcol__blocks[data-index=${index}]`).removeClass('hide')
                } else {
                    console.log('ne')
                    $(container).find('.dcol__col').removeClass('dcol__col--blocks')
                    $(container).removeClass('dcol--selected')
                }
                $('.dcol__inner-text').hide();
                $(`.dcol__inner-text[data-index="${index}"]`).show();

                $(container).find('.dcol__inner-title span').html(tagTitle);
                if(sliders[id] && sliders[id].swiper) {
                    sliders[id].swiper.destroy();
                }
                if(selected && $(window).width() < 992) {
                    $(container).find('.dcol__blocks--mob').clone().appendTo($(container).find('.dcol__slider .swiper-wrapper'))
                }
                $(container).find('.dcol__fake').find('.dcol__slide').each(function(index) {
                    let tags = $(this).attr('data-tags').split(',')
                    if(tags.indexOf(tag) !== -1) {
                        $(this).clone().appendTo($(container).find('.dcol__slider .swiper-wrapper'))
                    }

                    if(index + 1 === count) {
                        sliders[id] = {};
                        sliders[id].swiper = new Swiper(`[data-id="${id}"] .dcol__slider`, {
                            spaceBetween: 20,
                            slidesPerView: 'auto',
                            observer: true,
                            observeParents: true,
                            watchSlidesVisibility: true,
                            watchSlidesProgress: true,
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            breakpoints :{
                                992:{
                                    spaceBetweenSlides: 10
                                },
                                1600:{
                                    spaceBetweenSlides: 30
                                }
                            },
                        });
                    }
                })
                $(this).siblings('.dcol__tab').removeClass('active');
                $(this).addClass('active');
            }
        })

        $('.dcol__tabs').each(function() {
            let tabSlider = new Swiper($(this)[0], {
                slidesPerView: 'auto',
                freeMode: true,
            })
        })

        $(document).on('click', '.dcol__size', function(e) {
            let elem = $(e.target).closest('.dcol__size')
            let index = $(elem).attr('data-index');
            $(elem).siblings('.dcol__size').removeClass('active');
            $(elem).addClass('active');

            $(elem).closest('.dcol__blocks').find('.dcol__block').removeClass('active');
            $(elem).closest('.dcol__blocks').find(`.dcol__block[data-index="${index}"]`).addClass('active');
        })
    }

    function sizeTabs() {
        $('.size__tab').click(function() {
            let index = $(this).attr('data-index');
            $('.size__tab').removeClass('active');
            $(this).addClass('active');
            $('.size__table').hide();
            $(`.size__table[data-index="${index}"]`).show();
        })
    }

    // var image = document.getElementsByClassName('dcol__head-img-img');
    // new simpleParallax(image, {
    //     scale: 1.5,
    // });

    $('.feature_button').click(function(e) {
        let id = $(this).attr('href')
        if(id.includes('#')){
            e.preventDefault();
            let to = $(id).offset().top - 90;
            $('html, body').animate({ scrollTop: to }, 800);
        }
    })

    $('.c-text__btn').click(() => {
        $('.c-text__btn span').toggle();
        $('[data-long-text]').toggle();
    })


    bannerSlider();
    colSlider();
    sizeTabs();
})